import React, { useMemo, useState, useCallback } from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import { provider } from 'web3-core'
import { getContract } from 'utils/erc20'
import { Button, Flex, Text } from '@pancakeswap-libs/uikit'
import UnlockButton from 'components/UnlockButton'
import useI18n from 'hooks/useI18n'
import { useERC20 } from 'hooks/useContract'
import { useAllowance } from 'hooks/useAllowance'
import { useTokenApprove } from 'hooks/useApprove'
import StakeAction from './StakeAction'
import HarvestAction from './HarvestAction'

const Action = styled.div`
  padding-top: 16px;
`

interface CardActionsProps {
  ranch: any
  lpLabel: string
  account?: string
}

const CardActions: React.FC<CardActionsProps> = ({ ranch, lpLabel, account }) => {
  const TranslateString = useI18n()
  const { token, lpToken } = ranch;

  const lpTokenContract = useERC20(lpToken.address);
  const [requestedLpApproval, setRequestedLpApproval] = useState(false)
  const [lpApproved, setLpApproved] = useState(0)
  const lpAllowance = useAllowance(lpTokenContract, ranch.address, lpApproved);
  const onLpApprove = useTokenApprove(lpTokenContract, ranch.address)
  const lpAllowed = lpAllowance && !lpAllowance.isLessThan(new BigNumber(10).pow(77));

  const handleLpApprove = useCallback(async () => {
      try {
        setRequestedLpApproval(true)
        const txHash = await onLpApprove()
        if (txHash) setLpApproved(lpApproved+1)
        setRequestedLpApproval(false)
      } catch (e) {
        console.error(e)
      }
    }, [onLpApprove, lpApproved])

  const renderApprovalOrStakeButton = () => {
    return lpAllowed ? (
      <StakeAction ranch={ranch} lpLabel={lpLabel} />
    ) : (
      <Button mt="8px" fullWidth disabled={requestedLpApproval} onClick={handleLpApprove}>
        {TranslateString(139, 'Approve Contract')}
      </Button>
    )
  }

  return (
    <Action>
      <Flex>
        <Text bold textTransform="uppercase" color="secondary" fontSize="12px" pr="3px">
          {token.symbol}
        </Text>
        <Text bold textTransform="uppercase" color="textSubtle" fontSize="12px">
          {TranslateString(91, 'Earned')}
        </Text>
      </Flex>
      <HarvestAction ranch={ranch} />
      <Flex>
        <Text bold textTransform="uppercase" color="secondary" fontSize="12px" pr="3px">
          {lpLabel}
        </Text>
        <Text bold textTransform="uppercase" color="textSubtle" fontSize="12px">
          {TranslateString(92, 'Staked')}
        </Text>
      </Flex>
      {!account ? <UnlockButton mt="8px" fullWidth /> : renderApprovalOrStakeButton()}
    </Action>
  )
}

export default CardActions
